import React, { useState } from 'react';
import { View, Text, StyleSheet, Platform, TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import PrimaryButton from '../components/PrimaryButton';

const SuspendedScreen = () => {
  const { palette, mode } = useTheme();
  const { user, logout } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
      // Navigation will be handled automatically by NavigationContext
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <View style={[styles.container]}>
      <View style={styles.content}>
        <View style={[styles.iconContainer, { backgroundColor: palette.surface || 'rgba(234, 128, 107, 0.10)' }]}>
          <MaterialCommunityIcons 
            name="account-off" 
            size={64} 
            color={palette.error || '#EA806B'} 
          />
        </View>
        
        <Text style={[styles.title, { color: palette.text || 'white' }]}>
          Account Suspended
        </Text>
        
        <Text style={[styles.message, { color: palette.mutedText || 'rgba(255,255,255,0.60)' }]}>
          Your account has been temporarily suspended. Please contact support for assistance.
        </Text>
        
        {user?.email && (
          <View style={[styles.emailContainer, { borderColor: palette.border || 'rgba(255,255,255,0.16)' }]}>
            <Text style={[styles.emailLabel, { color: palette.mutedText || 'rgba(255,255,255,0.60)' }]}>
              Account Email:
            </Text>
            <Text style={[styles.email, { color: palette.text || 'white' }]}>
              {user.email}
            </Text>
          </View>
        )}
        
        <View style={styles.supportInfo}>
          <Text style={[styles.supportText, { color: palette.mutedText || 'rgba(255,255,255,0.60)' }]}>
            If you believe this is an error, please reach out to our support team.
          </Text>
            <View style={styles.logoutContainer}>
            <PrimaryButton
                title={loggingOut ? 'Logging out...' : 'Logout'}
                onPress={handleLogout}
                disabled={loggingOut}
                style={styles.logoutButton}
            />
            </View>
        </View>
        
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    minHeight: '120vh',
    alignItems: 'center',
    padding: Platform.OS === 'web' ? 48 : 24,
    ...Platform.select({
      web: {
        minHeight: 'calc(100vh - 48px)', // Account for navbar
      },
    }),
  },
  content: {
    width: '100%',
    maxWidth: 600,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    paddingTop: 80,
  },
  iconContainer: {
    width: 120,
    height: 120,
    borderRadius: 60,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
  },
  title: {
    fontSize: 32,
    fontFamily: 'Archivo',
    fontWeight: '600',
    lineHeight: 40,
    textAlign: 'center',
    marginBottom: 8,
  },
  message: {
    fontSize: 17,
    fontFamily: 'Public Sans',
    fontWeight: '400',
    lineHeight: 24,
    textAlign: 'center',
    marginBottom: 16,
  },
  emailContainer: {
    width: '100%',
    padding: 20,
    borderRadius: 12,
    borderWidth: 1,
    backgroundColor: 'transparent',
    gap: 8,
    marginTop: 8,
  },
  emailLabel: {
    fontSize: 13,
    fontFamily: 'Public Sans',
    fontWeight: '400',
    lineHeight: 16,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  email: {
    fontSize: 17,
    fontFamily: 'Public Sans',
    fontWeight: '500',
    lineHeight: 24,
  },
  supportInfo: {
    width: '100%',
    marginTop: 16,
    paddingTop: 24,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.08)',
  },
  supportText: {
    fontSize: 15,
    fontFamily: 'Public Sans',
    fontWeight: '400',
    lineHeight: 22,
    textAlign: 'center',
  },
  logoutContainer: {
    width: '100%',
    marginTop: 32,
  },
  logoutButton: {
    maxWidth: 300,
    alignSelf: 'center',
  },
});

export default SuspendedScreen;

